import SignupForm from "../Components/Signup/SignupForm";
import Layout from "../Layout/Layout";

const Signup = () => {
  return (
    <Layout>
      <SignupForm />
    </Layout>
  );
};

export default Signup;
